import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LayoutModule } from '../layout/layout.module';
import { SharedModule } from '../shared/shared.module';

import { AuthRoutingModule } from './auth-routing.module';

import { AuthService } from './shared/services/auth.service';

import { RegisterPageComponent } from './register/containers/register-page.component';
import { RegisterModule } from './register/register.module';
import { LayoutAuthComponent } from '../layout/containers/layout-auth.component';
import { LoginModule } from './login/login.module';
import { ForgotPasswordModule } from './forgot-password/forgot-password.module';
import { AuthPageComponent } from './__/containers/auth-page.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AuthRoutingModule,

    LayoutModule,
    RegisterModule,
    LoginModule,
    ForgotPasswordModule
  ],
  declarations: [
    RegisterPageComponent,
    AuthPageComponent
  ],
  exports: [
    AuthRoutingModule,
  ],
  providers: [AuthService]
})
export class AuthModule {
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/auth.module.ts